import { Router } from 'express';
import { authMiddleware, optionalAuthMiddleware } from '../../middleware/auth.middleware';
import * as controller from './meeting.controller';

const router = Router();

// Authenticated routes
router.post('/', authMiddleware, controller.createMeetingHandler);
router.get('/', authMiddleware, controller.listMeetingsHandler);
router.patch('/:id', authMiddleware, controller.updateMeetingHandler);
router.delete('/:id', authMiddleware, controller.deleteMeetingHandler);
router.get('/:id/report', authMiddleware, controller.getMeetingReportHandler);

// Guest & Public accessible routes
router.get('/:idOrCode', optionalAuthMiddleware, controller.getMeetingHandler);
router.post('/:id/join', optionalAuthMiddleware, controller.joinMeetingHandler);
router.post('/:id/leave', optionalAuthMiddleware, controller.leaveMeetingHandler);
router.post('/:id/transcript', optionalAuthMiddleware, controller.appendTranscriptHandler);

export default router;
